<template>
  <v-panel>
    <v-form ref="form">
      <div class="divider">
        <span>
          <b>Dados dos Recursos - Pastagens e Outros</b>
        </span>
      </div>
      <v-flex md11>
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Pastagem cultivada</b>
          </span>
        </div>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloPastagemCultivada01"
                  placeholder="Pastagem Cultivada"
                  v-model="formulario.TituloPastagemCultivada01"
                  background-color="white"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade (Total)</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="QuantidadeTotal01"
                  v-model="formulario.QuantidadeTotal01"
                  type="number"
                  background-color="white"
                  label="ha"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="BovinoCultura01"
                  v-model="formulario.BovinoCultura01"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorInicial01"
                      v-model="formulario.ValorInicial01"
                      type="number"
                      background-color="white"
                      label="R$/ha"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorResidual01"
                      v-model="formulario.ValorResidual01"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="VidaUtil01"
                  v-model="formulario.VidaUtil01"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!---->
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloPastagemCultivada02"
                  placeholder="Pastagem Cultivada"
                  v-model="formulario.TituloPastagemCultivada02"
                  background-color="white"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade (Total)</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="QuantidadeTotal02"
                  v-model="formulario.QuantidadeTotal02"
                  type="number"
                  background-color="white"
                  label="ha"
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="BovinoCultura02"
                  v-model="formulario.BovinoCultura02"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorInicial01"
                      v-model="formulario.ValorInicial02"
                      type="number"
                      background-color="white"
                      label="R$/ha"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorResidual02"
                      v-model="formulario.ValorResidual02"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="VidaUtil02"
                  v-model="formulario.VidaUtil02"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!---->
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloPastagemCultivada03"
                  placeholder="Pastagem Cultivada"
                  v-model="formulario.TituloPastagemCultivada03"
                  background-color="white"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade (Total)</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="QuantidadeTotal03"
                  v-model="formulario.QuantidadeTotal03"
                  type="number"
                  background-color="white"
                  label="ha"
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="BovinoCultura03"
                  v-model="formulario.BovinoCultura03"
                  type="number"
                  background-color="white"
                  label="%"
                ></v-text-field>
              </v-flex>
              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorInicial03"
                      v-model="formulario.ValorInicial03"
                      type="number"
                      background-color="white"
                      label="R$/ha"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorResidual03"
                      v-model="formulario.ValorResidual03"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="VidaUtil03"
                  v-model="formulario.VidaUtil03"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!---->
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloPastagemCultivada04"
                  placeholder="Pastagem Cultivada"
                  v-model="formulario.TituloPastagemCultivada04"
                  background-color="white"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade (Total)</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="QuantidadeTotal04"
                  v-model="formulario.QuantidadeTotal04"
                  type="number"
                  background-color="white"
                  label="ha"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="BovinoCultura04"
                  v-model="formulario.BovinoCultura04"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorInicial04"
                      v-model="formulario.ValorInicial04"
                      type="number"
                      background-color="white"
                      label="R$/ha"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorResidual04"
                      v-model="formulario.ValorResidual04"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="VidaUtil04"
                  v-model="formulario.VidaUtil04"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!---->
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloPastagemCultivada05"
                  placeholder="Pastagem Cultivada"
                  v-model="formulario.TituloPastagemCultivada05"
                  background-color="white"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade (Total)</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="QuantidadeTotal05"
                  v-model="formulario.QuantidadeTotal05"
                  type="number"
                  background-color="white"
                  label="ha"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="BovinoCultura05"
                  v-model="formulario.BovinoCultura05"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorInicial05"
                      v-model="formulario.ValorInicial05"
                      type="number"
                      background-color="white"
                      label="R$/ha"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorResidual05"
                      v-model="formulario.ValorResidual05"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="VidaUtil05"
                  v-model="formulario.VidaUtil05"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!---->
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloPastagemCultivada06"
                  placeholder="Pastagem Cultivada"
                  v-model="formulario.TituloPastagemCultivada06"
                  background-color="white"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade (Total)</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="QuantidadeTotal06"
                  v-model="formulario.QuantidadeTotal06"
                  type="number"
                  background-color="white"
                  label="ha"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="BovinoCultura06"
                  v-model="formulario.BovinoCultura06"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorInicial06"
                      v-model="formulario.ValorInicial06"
                      type="number"
                      background-color="white"
                      label="R$/ha"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorResidual06"
                      v-model="formulario.ValorResidual06"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="VidaUtil06"
                  v-model="formulario.VidaUtil06"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!---->
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloPastagemCultivada07"
                  placeholder="Pastagem Cultivada"
                  v-model="formulario.TituloPastagemCultivada07"
                  background-color="white"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade (Total)</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="QuantidadeTotal07"
                  v-model="formulario.QuantidadeTotal07"
                  type="number"
                  background-color="white"
                  label="ha"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="BovinoCultura07"
                  v-model="formulario.BovinoCultura07"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorInicial07"
                      v-model="formulario.ValorInicial07"
                      type="number"
                      background-color="white"
                      label="R$/ha"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorResidual07"
                      v-model="formulario.ValorResidual07"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="VidaUtil07"
                  v-model="formulario.VidaUtil07"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!---->
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloPastagemCultivada08"
                  placeholder="Pastagem Cultivada"
                  v-model="formulario.TituloPastagemCultivada08"
                  background-color="white"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade (Total)</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="QuantidadeTotal08"
                  v-model="formulario.QuantidadeTotal08"
                  type="number"
                  background-color="white"
                  label="ha"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="BovinoCultura08"
                  v-model="formulario.BovinoCultura08"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorInicial08"
                      v-model="formulario.ValorInicial08"
                      type="number"
                      background-color="white"
                      label="R$/ha"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorResidual08"
                      v-model="formulario.ValorResidual08"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="VidaUtil08"
                  v-model="formulario.VidaUtil08"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!---->
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloPastagemCultivada09"
                  placeholder="Pastagem Cultivada"
                  v-model="formulario.TituloPastagemCultivada09"
                  background-color="white"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade (Total)</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="QuantidadeTotal09"
                  v-model="formulario.QuantidadeTotal09"
                  type="number"
                  background-color="white"
                  label="ha"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="BovinoCultura09"
                  v-model="formulario.BovinoCultura09"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorInicial09"
                      v-model="formulario.ValorInicial09"
                      type="number"
                      background-color="white"
                      label="R$/ha"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorResidual09"
                      v-model="formulario.ValorResidual09"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="VidaUtil09"
                  v-model="formulario.VidaUtil09"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!---->
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <v-text-field
                  name="TituloPastagemCultivada10"
                  placeholder="Pastagem Cultivada"
                  v-model="formulario.TituloPastagemCultivada10"
                  background-color="white"
                ></v-text-field>
              </span>
            </div>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade (Total)</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="QuantidadeTotal10"
                  v-model="formulario.QuantidadeTotal10"
                  type="number"
                  background-color="white"
                  label="ha"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="BovinoCultura10"
                  v-model="formulario.BovinoCultura10"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorInicial10"
                      v-model="formulario.ValorInicial10"
                      type="number"
                      background-color="white"
                      label="R$/ha"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorResidual10"
                      v-model="formulario.ValorResidual10"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="VidaUtil10"
                  v-model="formulario.VidaUtil10"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <!-- Areas para produção de volumosos -->
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Áreas para produção de volumosos</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <div class="divider2 text-xs-center">
              <span>
                <b>Capineiras</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade (Total)</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="QuantidadeTotalCapineiras"
                  v-model="formulario.QuantidadeTotalCapineiras"
                  type="number"
                  background-color="white"
                  label="ha"
                  box                  
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="BovinoCulturaCapineiras"
                  v-model="formulario.BovinoCulturaCapineiras"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorInicialCapineiras"
                      v-model="formulario.ValorInicialCapineiras"
                      type="number"
                      background-color="white"
                      label="R$/ha"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorResidualCapineiras"
                      v-model="formulario.ValorResidualCapineiras"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="VidaUtilCapineiras"
                  v-model="formulario.VidaUtilCapineiras"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-flex xs10 sm7 md7>
              <div class="divider2 text-xs-center">
                <span>
                  <b>Cultivos para silagem</b>
                </span>
              </div>
              <v-divider></v-divider>
              <v-layout align-center justify-center row wrap>
                <v-flex xs6 sm5 md5>
                  <div class="divider2 text-xs-center">
                    <span>
                      <b>Ha</b>
                    </span>
                  </div>
                  <v-divider></v-divider>
                  <v-text-field
                    name="HaSilagem"
                    v-model="formulario.HaSilagem"
                    type="number"
                    background-color="white"
                    label="ha"
                    box
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm5 md5>
                  <div class="divider2 text-xs-center">
                    <span>
                      <b>Duração do ciclo de cultivos</b>
                    </span>
                  </div>
                  <v-divider></v-divider>
                  <v-text-field
                    name="MesesSilagem"
                    v-model="formulario.MesesSilagem"
                    type="number"
                    background-color="white"
                    label="meses"
                    box
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-flex>
        </v-layout>
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Outras áreas com cultivo permanente</b>
          </span>
        </div>
        <v-divider></v-divider>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 sm8 md8>
            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Quantidade (Total)</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="QuantidadeTotalOutras"
                  v-model="formulario.QuantidadeTotalOutras"
                  type="number"
                  background-color="white"
                  label="ha"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Utilização na bovinocultura de corte</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="BovinoCulturaOutras"
                  v-model="formulario.BovinoCulturaOutras"
                  type="number"
                  background-color="white"
                  label="%"
                  box
                ></v-text-field>
              </v-flex>
              <v-flex xs10 sm7 md7>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Valor</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-layout align-center justify-center row wrap>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Inicial</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorInicialOutras"
                      v-model="formulario.ValorInicialOutras"
                      type="number"
                      background-color="white"
                      label="R$/ha"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm5 md5>
                    <div class="divider2 text-xs-center">
                      <span>
                        <b>Residual</b>
                      </span>
                    </div>
                    <v-divider></v-divider>
                    <v-text-field
                      name="ValorResidualOutras"
                      v-model="formulario.ValorResidualOutras"
                      type="number"
                      background-color="white"
                      label="%"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <div class="divider2 text-xs-center">
                  <span>
                    <b>Vida útil</b>
                  </span>
                </div>
                <v-divider></v-divider>
                <v-text-field
                  name="VidaUtilOutras"
                  v-model="formulario.VidaUtilOutras"
                  type="number"
                  background-color="white"
                  label="Anos"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Taxa de juros para calcular o custo do capital imobilizado em pastagens, capineiras e outros cultivos permanentes</b>
          </span>
        </div>
        <v-divider></v-divider>
        <v-layout align-center justify row wrap>
          <v-flex xs6 sm5 md5>
            <v-text-field
              name="TaxaJurosPastagens"
              v-model="formulario.TaxaJurosPastagens"
              type="number"
              background-color="white"
              label="% anual"
              box
            ></v-text-field>
            {{form}}
          </v-flex>
        </v-layout>
      </v-flex>
    </v-form>
  </v-panel>
</template>
<script>
/* eslint-disable */
import DadosRecursosPastagensOutros from "../../class/DadosRecursosPastagensOutros.js";
export default {
  inject: ["$validator"],
  data: () => ({
    formulario: new DadosRecursosPastagensOutros(),
    panel: [],
    simulation: ''
  }),
  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed: {
    form: function() {
      this.$db.simulation.get({ code: this.simulation.code }, dado => {
        this.formulario = new DadosRecursosPastagensOutros(dado.dadosRecursosPastagensOutros);
      });
    }
  },
  methods: {
    clear() {
      this.formulario = {
        formulario: Object.assign(this.$data, this.$options.data.apply())
      };
      this.$validator.reset();
    }
  }
};
</script>
<style scoped>
h2 {
  color: #00695c;
}

.botaoNone {
  border: solid black 1px;
  position: fixed;
  margin-bottom: 0;
  z-index: 997;
  bottom: 45px;
  right: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

@media screen and (max-width: 991px) {
  h2 {
    color: #00695c;
  }
  .container {
    position: relative;
    text-align: center;
    background-color: #00695c;
    min-height: 100vh;
    max-width: none;
    color: azure;
  }
  .panel {
    margin-top: 1%;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 15px black;
  }
  .form {
    margin-top: 2%;
    min-width: 100%;
  }
  .text-field {
    background-color: blue;
    font-size: 2px;
  }
  .select {
    background-color: blue;
    font-size: 2px;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }
  .button {
    float: right;
  }
  .divider {
    text-align: center;
    font-size: 130%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    margin-top: 5%;
    margin-left: 5%;
    font-size: 110%;
  }
}

@media screen and (min-width: 992px) {
  h2 {
    color: #00695c;
  }
  .container {
    margin-top: 2%;
    text-align: center;
    background-color: #00695c;
    min-height: 100vh;
    max-width: none;
    color: azure;
  }
  .panel {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 10px black;
  }
  .panelGrafico {
    width: 70%;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }
  .button {
    float: right;
  }
  .divider {
    text-align: center;
    font-size: 180%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    font-size: 150%;
    margin-top: 5%;
    margin-left: 5%;
  }
  .layout {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>